module.exports = __webpack_public_path__ + "static/img/logo2.de03ee56.png";